import { getCollectionNode, setCollectionNode } from 'shared-utils/src/myCasaCollections';

import { useCtxGlobal } from '@client/app/Container';

import { MY_COLLECTIONS_IDS, MY_COLLECTIONS_TYPES } from 'shared-constants/src/mycasa26/collection_configurations';

import { saveAddressCollection, deleteAddressCollection } from '@client/helpers/MyCasaHelpers';


import { getName, getDetails } from './getAddressStrings';

export default ({
  map = null,
  libraries = null,
  editAddressSuccessAction,
}) => {
  const {
    showHandleAddressesModal,
    globalState,
  } = useCtxGlobal() || {};

  const updateFavorites = (favorites, fav, deleted = false, changedPosition = false) => {
    const portal26Domain = globalState && globalState.config && globalState.config.api && globalState.config.api.portal26;
    setCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.SAVED, { data: favorites, count: favorites.length });

    if (deleted) {
      deleteAddressCollection(portal26Domain, MY_COLLECTIONS_IDS.SAVED, [fav.id]);
    } else {
      saveAddressCollection(portal26Domain, MY_COLLECTIONS_IDS.SAVED, fav);
    }

    const {
      customName,
      street,
      number,
      town,
      latitude,
      longitude,
    } = fav;

    const pinDefaultConfiguration = {
      isPin: true,
      lat: latitude,
      lon: longitude,
      favorite: !deleted,
      uKey: `pin_${latitude},${longitude}`,
    };

    const pinConfiguration = !deleted ? {
      ...pinDefaultConfiguration,
      name: getName({
        customName,
        street,
        number,
        town,
      }),
      parent: getDetails({
        customName,
        street,
        number,
        town,
      }),
    } : {
      ...pinDefaultConfiguration,
      name: `${street}${number ? ` ${number}` : ''}`,
      parent: town,
    };

    editAddressSuccessAction({ pinConfiguration, changedPosition });
  };

  const manageFavoriteAddresses = (address) => {
    const {
      core,
      geocoding,
      places,
    } = libraries;

    const favorites = getCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.SAVED)?.data || [];
    const addrLat = address.latitude !== undefined ? address.latitude : address.lat;
    const addrLon = address.longitude !== undefined ? address.longitude : address.lon;
    const favorite = favorites.filter(addr =>
      addr.latitude === addrLat && addr.longitude === addrLon
    )[0];

    showHandleAddressesModal({
      type: 'edit-bookmark',
      data: favorites,
      toedit: favorite,
      actions: { updateFavorites },
      libraries: {
        map,
        core,
        geocoding,
        places,
      },
      recent: getCollectionNode(MY_COLLECTIONS_TYPES.ADDRESSES, MY_COLLECTIONS_IDS.RECENT)?.data || [],
    });
  };

  return { manageFavoriteAddresses };
};
